// extracted by mini-css-extract-plugin
export default {"titles":"ErrorPageFragment_titles__dBzOB","icon":"ErrorPageFragment_icon__Z4NUV"};